import * as i0 from '@angular/core';
import { Component, Input } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
function ButtonComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 3);
    i0.ɵɵelement(2, "path", 4)(3, "path", 5);
    i0.ɵɵelementEnd()();
  }
}
function InputComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "label", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.labelText, " ");
  }
}
function InputComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.errorMessageInternal, " ");
  }
}
let ButtonComponent = /*#__PURE__*/(() => {
  class ButtonComponent {
    constructor() {
      /**
       * How large should the button be?
       */
      this.size = 'medium';
      this.buttonType = 'button';
      /**
       * Button contents
       *
       * @required
       */
      this.label = 'Button';
      /**
       * Disabled Button
       */
      this.disabled = false;
      /**
       * Button is loading
       */
      this.isLoading = false;
    }
    get class() {
      return ['aprova-button', `aprova-button--${this.size}`];
    }
    static {
      this.ɵfac = function ButtonComponent_Factory(t) {
        return new (t || ButtonComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonComponent,
        selectors: [["aprova-button"]],
        inputs: {
          size: "size",
          buttonType: "buttonType",
          label: "label",
          disabled: "disabled",
          isLoading: "isLoading"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 10,
        consts: [[3, "type"], ["class", "loader-animation"], [1, "loader-animation"], ["aria-hidden", "true", "role", "status", "viewBox", "0 0 100 101", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", 1, "spinner"], ["d", "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z", "fill", "#E5E7EB"], ["d", "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z", "fill", "currentColor"]],
        template: function ButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵtext(1);
            i0.ɵɵtemplate(2, ButtonComponent_Conditional_2_Template, 4, 0, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
            i0.ɵɵclassProp("aprova-button--disabled", ctx.disabled)("aprova-button--loading", ctx.isLoading);
            i0.ɵɵproperty("type", ctx.buttonType);
            i0.ɵɵattribute("disabled", ctx.disabled ? true : null);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(2, ctx.isLoading ? 2 : -1);
          }
        },
        styles: [".aprova-button[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;color:#fff;background-color:#06929f;font-family:Inter,Nunito Sans,Helvetica Neue,Helvetica,Arial,sans-serif;font-weight:100;border:0;border-radius:8px;cursor:pointer;line-height:1;width:100%}.aprova-button--small[_ngcontent-%COMP%]{color:#fff;font-size:14px;padding:10px 16px;height:36px}.aprova-button--medium[_ngcontent-%COMP%]{color:#fff;font-size:16px;padding:11px 20px;height:44px}.aprova-button--large[_ngcontent-%COMP%]{color:#fff;font-size:18px;padding:12px 24px;height:60px}.aprova-button--disabled[_ngcontent-%COMP%]{cursor:not-allowed;background-color:#a9acb1;color:#d4d5d8}[_ngcontent-%COMP%]:hover.aprova-button{background-color:#003a40}[_ngcontent-%COMP%]:hover.aprova-button--disabled{background-color:#a9acb1;color:#d4d5d8}.aprova-button--loading[_ngcontent-%COMP%]{padding-left:30px}.aprova-button--loading[_ngcontent-%COMP%]   .loader-animation[_ngcontent-%COMP%]{display:flex;animation:_ngcontent-%COMP%_fadeSlideIn .3s ease-in-out;padding-left:8px;opacity:1}.aprova-button--loading[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{display:inline;color:#fff;width:16px;height:16px;margin-inline-end:12px;animation:_ngcontent-%COMP%_spin 1s linear infinite}@keyframes _ngcontent-%COMP%_fadeSlideIn{0%{opacity:0;transform:translate(-20px)}to{opacity:1;transform:translate(0)}}@keyframes _ngcontent-%COMP%_spin{to{transform:rotate(360deg)}}"]
      });
    }
  }
  return ButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputComponent = /*#__PURE__*/(() => {
  class InputComponent {
    constructor() {
      this.inputType = 'text';
      this.labelText = '';
      this.placeholder = '';
      this.readonly = false;
      this.disabled = false;
      this.maxLength = null;
      this.required = false;
      this.requiredTag = false;
      this.optionalTag = false;
      this.errorMessages = {};
      this.control = new FormControl('');
    }
    ngOnInit() {
      if (this.disabled) {
        this.control.disable({
          emitEvent: false
        });
      } else {
        this.control.enable({
          emitEvent: false
        });
      }
    }
    get hasError() {
      const someError = Object.values(this.control.errors || {}).some(Boolean);
      return someError && this.control.invalid && (this.control.dirty || this.control.touched);
    }
    get errorMessageInternal() {
      const key = Object.keys(this.control.errors || {}).find(Boolean);
      return key && this.errorMessages[key] ? this.errorMessages[key] : '';
    }
    static {
      this.ɵfac = function InputComponent_Factory(t) {
        return new (t || InputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputComponent,
        selectors: [["aprova-input"]],
        inputs: {
          inputType: "inputType",
          labelText: "labelText",
          placeholder: "placeholder",
          readonly: "readonly",
          disabled: "disabled",
          maxLength: "maxLength",
          required: "required",
          requiredTag: "requiredTag",
          optionalTag: "optionalTag",
          errorMessages: "errorMessages",
          control: "control"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 17,
        vars: 8,
        consts: [[1, "box-input"], [1, "aprova-input", 3, "type", "placeholder", "formControl", "required", "readonly"], ["input", ""], ["class", "aprova-input-error-message"], [2, "width", "100%", "height", "100%", "flex-direction", "column", "justify-content", "flex-start", "align-items", "flex-start", "display", "inline-flex"], [2, "align-self", "stretch", "height", "70px", "flex-direction", "column", "justify-content", "flex-start", "align-items", "flex-start", "gap", "6px", "display", "flex"], [2, "color", "#808b98", "font-size", "14px", "font-family", "Inter", "font-weight", "100", "line-height", "20px", "word-wrap", "break-word"], [2, "align-self", "stretch", "height", "44px", "padding-left", "14px", "padding-right", "14px", "padding-top", "10px", "padding-bottom", "10px", "background", "white", "border-radius", "8px", "overflow", "hidden", "border", "1px #c4cbd1 solid", "justify-content", "flex-start", "align-items", "center", "gap", "8px", "display", "inline-flex"], [2, "flex", "1 1 0", "height", "12px", "justify-content", "flex-start", "align-items", "center", "gap", "8px", "display", "flex"], [2, "flex", "1 1 0", "color", "#808b98", "font-size", "16px", "font-family", "Inter", "font-weight", "100", "line-height", "24px", "word-wrap", "break-word"], [2, "width", "16px", "height", "16px", "position", "relative"], [1, "aprova-label"], [1, "aprova-input-error-message"]],
        template: function InputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵtemplate(1, InputComponent_Conditional_1_Template, 3, 1, "div");
            i0.ɵɵelementStart(2, "div", 0);
            i0.ɵɵelement(3, "input", 1, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div");
            i0.ɵɵtemplate(6, InputComponent_Conditional_6_Template, 2, 1, "p", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 4)(8, "div", 5)(9, "div", 5)(10, "div", 6);
            i0.ɵɵtext(11, " E-mail ");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "div", 7)(13, "div", 8)(14, "div", 9);
            i0.ɵɵtext(15, " Digite o seu e-mail ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(16, "div", 10);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(1, ctx.labelText ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("type", ctx.inputType)("placeholder", ctx.placeholder)("formControl", ctx.control)("required", ctx.required)("readonly", ctx.readonly);
            i0.ɵɵattribute("maxlength", ctx.maxLength);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(6, ctx.hasError ? 6 : -1);
          }
        },
        dependencies: [ReactiveFormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.RequiredValidator, i1.FormControlDirective],
        styles: [".aprova-input[_ngcontent-%COMP%]{border-radius:8px;border:1px solid #C4CBD1;width:100%;padding:.75rem 1rem;height:2.5rem}.aprova-input-error-message[_ngcontent-%COMP%]{color:red}.aprova-label[_ngcontent-%COMP%]{color:#808b98;font-size:14px;font-family:Inter;font-weight:100;line-height:20px;word-wrap:break-word}"]
      });
    }
  }
  return InputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of design-system
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, InputComponent };
